export * from './abstract-urs.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/advtech/urs/index.ts